@if (menuItems) {
    <div class="tucked-menu" [class.initial-menu]="!isSubSection">
        @for (item of menuItems; track item) {
            <div
                class="tucked-group"
                [class.expanded-group]="item | tabchildselected: mainMenu.activeMenuItem"
                [hidden]="item.hidden"
            >
                <div
                    class="tucked-item"
                    [class.clickable]="
                        item.clickable ||
                        (item.children &&
                            item.children.length > 0 &&
                            item.children[0].identifier !== mainMenu.activeMenuItem)
                    "
                    [class.active]="mainMenu.activeMenuItem === item.identifier"
                    (click)="clickMenuItem(item)"
                    (mouseenter)="mouseEnteredItem($event, item)"
                    (mouseleave)="mouseLeftItem()"
                >
                    <cerrix-icon-viewer
                        [icon]="item.iconClass"
                        defaultColor="white"
                    ></cerrix-icon-viewer>
                </div>
                @if (
                    item.children &&
                    item.children.length > 0 &&
                    (item | tabchildselected: mainMenu.activeMenuItem)
                ) {
                    <div class="tucked-children">
                        <tuckedmenu
                            [mainMenu]="mainMenu"
                            [parent]="item"
                            [menuItems]="item.children"
                            [isSubSection]="true"
                        ></tuckedmenu>
                    </div>
                }
            </div>
        }
    </div>
}

@if (hoverItem && (showHover || hoverMenuKeepOpen)) {
    <div
        class="hover-menu"
        [style.top]="hoverTop + 'px'"
        (mouseenter)="mouseEnteredHoverMenu()"
        (mouseleave)="mouseLeftHoverMenu()"
    >
        <div
            class="hover-menu-content"
            [class.active]="hoverItem.identifier === mainMenu.activeMenuItem"
            [class.expanded-group]="
                isSubSection || (hoverItem | tabchildselected: mainMenu.activeMenuItem)
            "
            [class.clickable]="
                showHover &&
                (hoverItem.clickable ||
                    (hoverItem.children &&
                        hoverItem.children.length > 0 &&
                        hoverItem.children[0].identifier !== mainMenu.activeMenuItem))
            "
        >
            @if (
                hoverItem.children &&
                hoverItem.children.length > 0 &&
                !(hoverItem | tabchildselected: mainMenu.activeMenuItem)
            ) {
                <ng-container [ngTemplateOutlet]="sidemenuContent"></ng-container>
            } @else {
                <ng-container [ngTemplateOutlet]="tooltipContent"></ng-container>
            }
        </div>
    </div>
}

<ng-template #tooltipContent>
    <div class="hover-tooltip">
        <label>{{ hoverItem.name }}</label>
    </div>
</ng-template>

<ng-template #sidemenuContent>
    <div class="hover-sidemenu">
        <ng-container [ngTemplateOutlet]="tooltipContent"></ng-container>
        <div class="children">
            @for (child of hoverItem.children; track child) {
                <div class="child-item" (click)="clickMenuItem(child)">
                    <div class="child-info">
                        <div class="icon">
                            <cerrix-icon-viewer
                                [icon]="child.iconClass"
                                defaultColor="white"
                            ></cerrix-icon-viewer>
                        </div>
                        <span> {{ child.name }} </span>
                    </div>
                </div>
            }
        </div>
    </div>
</ng-template>
